export default __webpack_public_path__ + "static/media/how-works-small.ceadd20e.png";